import React, { useEffect, useState, useRef, forwardRef, useImperativeHandle } from 'react';
import { useSelector } from "react-redux";
import GoogleMapReact from 'google-map-react';
import PUIcon from '../../assets/Images/MapImages/PUMarker.png'; // Correct path to your stop icon
import hull from 'hull.js'; // Import the convex hull library
import stopIcon from '../../assets/Images/locationicon.png'; 
import APICom from "../../utils/helpers/APICom.js";

// Custom marker component
// const StopMarker = ({ icon }) => (
//   <div>
//     <img src={icon} alt="Stop Icon" style={{ width: '10px', height: '10px' }} />
//   </div>
// );


const StopMarker = ({ lat, lng, icon, map }) => {
  useEffect(() => {
    const marker = new window.google.maps.Marker({
      position: { lat, lng },
      map,
      icon, // This is the dynamic icon
    });

    return () => {
      marker.setMap(null); // Clean up marker on unmount
    };
  }, [lat, lng, icon, map]);

  return null; // No visible React content needed
};

const RCZControlMap = forwardRef(({ initialStops, center, zoom , onSave, nameOfCityCounty, IsSearchButtonClicked, 
  IsResetBtnClicked, onSearchComplete, onResetComplete, plottedStops,
    AddressComponentData, IsReloadStopsButtonClicked, onReloadStopsComplete, 
    SavedPolygone, onStopsLoadedFromAPI
    }, ref) => {
    const [stops, setStops] = useState(initialStops); // Manage stops locally
    const [map, setMap] = useState(null);
    const [polygon, setPolygon] = useState(null);
    const mapRef = useRef(null);
    const [busStops, setBusStops] = useState([]);
    const xCancelSourceForGrid = useRef(null);
    const [MinStopsCounToRevGeoCode , setMinStopsCounToRevGeoCode] = useState(200);
    const [NoOfStopsToSave , setNoOfStopsToSave ] = useState(0);
    const markersRef = useRef(new Map()); 
    const[removeExistingStops, setremoveExistingStops] = useState(false);
    // const { GlobalASCSData, ASCSSettingData, DispatchVehicleData, AffiliateData, FundingSourceData, ZoneVerticesData, 
    //   VirtualStopsData, RCZZoneVerticesData, PaymentTypesData, ClassOfServiceData, AttributesData, DispatchDriverData
    // } = useSelector((store) => store.combinedata);
    // const OSRM_Username = (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "ITCMapServiceUserName")).value;
    // const OSRM_Password = (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "ITCMapServicePassword")).value;
    // const ITCMapRawURL = selectedAff ? (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "ITCMapServiceURL")).value : "https://itcmap.itcurves.us/api/map/";
    const addressComponenets = [
      { key: "city", value: "" },
      { key: "state", value: "" },
      { key: "zip", value: "" },
      { key: "formatted_address", value: ""},
      { key: "CompleteAddresscomponent", value: ""}
    ];

    const addressComponentsRef = useRef();

    // Function to lighten a hex color
    const lightenHexColor = (hex, percent) => {
      let num = parseInt(hex.slice(1), 16),
      amt = Math.round(2.55 * percent),
      R = (num >> 16) + amt,
      G = (num >> 8 & 0x00FF) + amt,
      B = (num & 0x0000FF) + amt;

      return `#${(
            0x1000000 +
            (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
            (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
            (B < 255 ? (B < 1 ? 0 : B) : 255)
      )
      .toString(16)
      .slice(1)
      .toUpperCase()}`;
    };

    // Base gray color
    const baseGray = '#808080';
    // Lightened gray color
    const lighterGray = lightenHexColor(baseGray, 30); // 30% lighter

    //const lighterGray = '#D3D3D3';
    // Map style with the lighter gray color
    const mapStyles = [
      {
          featureType: 'landscape',
          elementType: 'geometry',
          stylers: [{ color: '#E5E5E5' }], // Light gray for land
      },
      {
          featureType: 'water',
          elementType: 'geometry',
          stylers: [{ color: '#A9CCE3' }], // Light blue for water
      },
      {
          featureType: 'road',
          elementType: 'geometry',
          stylers: [{ color: '#CCCCCC' }], // Gray for roads
      },
      {
          featureType: 'poi',
          elementType: 'geometry',
          stylers: [{ color: '#D3D3D3' }], // Slightly darker gray for points of interest
      },
      {
          featureType: 'transit',
          elementType: 'geometry',
          stylers: [{ color: '#B3B3B3' }], // Medium gray for transit lines
      },
      {
          elementType: 'labels.text.fill',
          stylers: [{ color: '#616161' }],
      },
      {
          elementType: 'labels.text.stroke',
          stylers: [{ color: '#f5f5f5' }],
      },
  ];

    useEffect(() => {
      // Fetch the configuration file
      fetch("/manifest.json")
          .then((response) => {
              if (!response.ok) {
                  throw new Error("Failed to load configuration file.");
              }
              return response.json();
          })
          .then((config) => {
            setMinStopsCounToRevGeoCode(config.MinStopsCounToRevGeoCode);
            setNoOfStopsToSave(config.NoOfStopsToSave); 

          })
          .catch((error) => {
              console.error("Error loading configuration:", error);
          });
  }, []);




    useEffect(() => {
        setStops(busStops);
        plottedStops(busStops);

        if (polygon) {
          const polygonVertices = polygon.getPath().getArray().map(vertex => ({
            lat: vertex.lat(),
            lng: vertex.lng(),
          }));
          onSave(polygonVertices, busStops);
        }
    }, [busStops]);



//   const handleAddStop = (lat, lng) => {
//     setStops([...stops, [lat, lng]]);
//   };

//   const handleRemoveStop = (index) => {
//     setStops(stops.filter((_, i) => i !== index));
//   };

// useEffect(() => {
//     if (map !== undefined) {
//       if (stops?.length > 0) {
//         // Calculate the convex hull of the stops
//         const polygonPoints = hull(stops, 10).map(point => ({
//           lat: point[0],
//           lng: point[1],
//         }));
  
//         if (polygon) {
//           // Update the existing polygon
//           polygon.setPath(polygonPoints);
//         } else {
//           // Create the polygon with border only
//           const newPolygon = new window.google.maps.Polygon({
//             paths: polygonPoints,
//             strokeColor: "#FF0000", // Red border
//             strokeOpacity: 1.0,
//             strokeWeight: 2,
//             fillColor: "#FFFFFF", // White fill to ensure transparency
//             fillOpacity: 0.2,
//             editable: true, // Make the polygon editable
//             draggable: false, // Make the polygon draggable
//             map: map,
//           });
  
//           setPolygon(newPolygon);
//         }
//       } else if (polygon) {
//         // Clear the polygon if stops length is 0
//         polygon.setMap(null);
//         setPolygon(null);
//       }
//     }
//   }, [map, stops]);
  

  useEffect(() => {
    if (polygon) {
      window.google.maps.event.addListener(polygon.getPath(), 'insert_at', () => {
        if (onSave) {
          const updatedPolygon = polygon.getPath().getArray().map(p => ({ lat: p.lat(), lng: p.lng() }));
          onSave(updatedPolygon, busStops);
        }
      });

      window.google.maps.event.addListener(polygon.getPath(), 'remove_at', () => {
        if (onSave) {
          const updatedPolygon = polygon.getPath().getArray().map(p => ({ lat: p.lat(), lng: p.lng() }));
          onSave(updatedPolygon, busStops);
        }
      });

      window.google.maps.event.addListener(polygon.getPath(), 'set_at', () => {
        if (onSave) {
          const updatedPolygon = polygon.getPath().getArray().map(p => ({ lat: p.lat(), lng: p.lng() }));
          onSave(updatedPolygon, busStops);
        }
      });
    }
  }, [polygon, onSave, busStops]);


  useImperativeHandle(ref, () => ({
    saveMapData() {
      if (polygon) {
        const polygonVertices = polygon.getPath().getArray().map(vertex => ({
          lat: vertex.lat(),
          lng: vertex.lng(),
        }));
        onSave(polygonVertices, stops);
      }
    },
  }));


  // New Code
  const [savedLocalPolygoneDataFromDb, setSavedLocalPolygoneDataFromDb] = useState(SavedPolygone);
  const [localIsRestButtonClicked, setLocalIsRestButtonClicked] = useState(IsResetBtnClicked);
  const [localIsSearchButtonClicked, setLocalIsSearchButtonClicked] = useState(IsSearchButtonClicked);
  const [localIsReloadStopsButtonClicked, setLocalIsReloadStopsButtonClicked] = useState(IsReloadStopsButtonClicked);
  useEffect(() => {
    setLocalIsSearchButtonClicked(IsSearchButtonClicked);
  },[IsSearchButtonClicked])

  useEffect(() => {
    setSavedLocalPolygoneDataFromDb(SavedPolygone);
  },[SavedPolygone])



  useEffect(() => {
    setLocalIsReloadStopsButtonClicked(IsReloadStopsButtonClicked);
  },[IsReloadStopsButtonClicked])


  useEffect(() => {
    if (map && polygon ) {
      // Get the vertices of the polygon

      if(localIsReloadStopsButtonClicked === true){

        const updatedPolygon = polygon.getPath().getArray().map(p => ({ lat: p.lat(), lng: p.lng() }));

        const bounds = new window.google.maps.LatLngBounds();
        updatedPolygon.forEach(vertex => {
          bounds.extend(new window.google.maps.LatLng(vertex.lat, vertex.lng));
        });
        

        
        let polygonCoordinates = [];
      
        let reducedCoordinates = [];
        
        reducedCoordinates = updatedPolygon;
        // for(let y = 0; y < reducedCoordinates.length; y++)
        // {
        //   if(y !== 0)
        //   {
        //     polygonCoordinates += " ";
        //   }
        //   polygonCoordinates += reducedCoordinates[y].lat + ' ' + reducedCoordinates[y].lng;
        // }

        for (let y = 0; y < reducedCoordinates.length; y++) {
          polygonCoordinates.push([reducedCoordinates[y].lng, reducedCoordinates[y].lat]); // [longitude, latitude]
        }


        fetchIntersectionsWithinPolygon(polygonCoordinates);

        onReloadStopsComplete();

      }
    
    }
  }, [map, polygon, localIsReloadStopsButtonClicked]);
  
  const getSkippingLatLngNumberForGettingStops = (lengthOfList) => {
    try {
      if(lengthOfList >= 0 && lengthOfList <= 100){
        return 1;
      }
      else if(lengthOfList >= 100 && lengthOfList <= 300){
        return 5;
      }
      else if(lengthOfList >= 300 && lengthOfList <= 600){
        return 10;
      }
      else if(lengthOfList >= 600 && lengthOfList <= 900){
        return 15;
      }
    } catch (error) {
      
    }
  }

  useEffect(() => {
    if (map && localIsSearchButtonClicked) {
      handleResetPolygon();
      if (nameOfCityCounty) {
        drawPolygonByName(nameOfCityCounty, savedLocalPolygoneDataFromDb);
      }
      setLocalIsSearchButtonClicked(false);
    }
  }, [nameOfCityCounty, map, localIsSearchButtonClicked, savedLocalPolygoneDataFromDb]);

  // useEffect(() => {
  //   if (map) {
  //     if(nameOfCityCounty != undefined && nameOfCityCounty != "" && IsSearchButtonClicked == true){
  //       drawPolygonByName(nameOfCityCounty);
  //       IsSearchButtonClicked = false;
  //     }
  //   }
  // },[nameOfCityCounty])

  useEffect(() => {
    if (map) {
      if(nameOfCityCounty != undefined && nameOfCityCounty != ""){
        drawPolygonByName(nameOfCityCounty);
      }
    }
  }, [map]);

  function headersToObject(headers) {
    try{
      let result = {};
      for (let [key, value] of headers.entries()) {
        result[key] = value;
      }
      return result;
    }
    catch(err){console.log(err); return [];}
  };

  const ReverseGeoCode = async(Lat, Lng) => {
    try{
      let param_string = "&AppType=" + "Simulation_Agent";
      let ITCMapServiceURL = 'https://itcmapb.itcurves.us/api/Map/'; //Get this setting from ASCS Setting
      let ITCMapServiceUserName = 'SIV'; //Get this setting from ASCS Setting
      let ITCMapServicePassword = 'barwoodpass';  //Get this setting from ASCS Setting
      let myHeaders = new Headers();
      myHeaders.append("Authorization", 'Basic '+btoa(ITCMapServiceUserName + ":" + ITCMapServicePassword));
      myHeaders.append('Content-Type', 'application/json');
      let headersObj = headersToObject(myHeaders);
      let addressAPI = ITCMapServiceURL + 'geocode?latlng=' + Lat + ',' + Lng + param_string;
      let OSRMResponse = await APICom.fetchData("full", addressAPI, "get", headersObj, {});
      return OSRMResponse;
      // $.ajax({
      //     url: ITCMapServiceURL + 'geocode?latlng=' + Lat + ',' + Lng + param_string,
      //     dataType: "json",
      //     beforeSend: function (xhr) {
      //         xhr.setRequestHeader("Authorization", "Basic " + btoa(ITCMapServiceUserName + ":" + ITCMapServicePassword));
      //     },
      //     crossDomain: true,
      //     success: function (response) {
      //         console.log(response);
      //     },
      //     error: function (jqXHR, textStatus, errorThrown) {
  
      //     }
      // });
    }
    catch(err){console.log(err);}
    
  }

  const fetchIntersectionsWithinPolygonOld = async (polygonCoordinates)=>{

      try {

        const params ={
          polygon_coords:polygonCoordinates
        }

        let response = await APICom.fetchData("main", "street_intersections/get_Intersections_Within_Polygon", "post", {}, params, xCancelSourceForGrid.current)
        
          const data = await response.data.stops;
          const geocoder = new window.google.maps.Geocoder();
          let complAdr = "";
          // Map stops data to the desired format
          let all_stops = data.map(element => ({
            lat: element.lat, // Latitude from the API
            lon: element.lon, // Longitude from the API
            name: element.name || "", // Optional name, default to empty string if not available
            street: element.street || "", // Optional street, default to empty string if not available
            state: element.state || "", // Optional state, default to empty string if not available
            zip: element.zip || "", // Optional ZIP code, default to empty string if not available
            bPublished: false
          }));

          let stops = []
        

          if (MinStopsCounToRevGeoCode  < 1){
            const gridSize = 20;
            stops = all_stops.length > 100 ? scatterPointsEvenly(all_stops, gridSize, 100): all_stops;

          }
          else{
            stops = all_stops;

          }
          // const stops = all_stops.length > 100 ? getRandomizedIntersections(all_stops, 100): all_stops;
          // let stops = all_stops.length > 100 ? all_stops.slice(0, 100) : all_stops;

          let LastGeoCodedCornerState = "";
          let LastGeoCodedCornerZip = "";

          let filteredStops = [];
          
          for(let k = 0; k < stops.length; k++)
          {
            if(stops[k].name === '' && stops[k].street === '')
            {
              // console.log("went here", stops[k]);
              if( MinStopsCounToRevGeoCode  < 1 || k < MinStopsCounToRevGeoCode ){

                try{
                  let reverseGeocodeResponse = await ReverseGeoCode(stops[k].lat, stops[k].lon);
                  if(reverseGeocodeResponse && reverseGeocodeResponse.data.status.toUpperCase() === "OK")
                  {
                    const addressComponents = reverseGeocodeResponse.data.results[0].address_components;
                    // const AllAddressParts= CommonFunctions.getAddressParts(addressComponents)
                    addressComponents.forEach(component => {
                      let state = "";
                      let zip = "";
                      if (component.types.includes("administrative_area_level_1")) {
                        state = component.short_name; // State
                        LastGeoCodedCornerState = state;
                        stops[k] = {
                          ...stops[k],
                          state: state
                        };
                      }
                      if (component.types.includes("postal_code")) {
                        zip = component.long_name; // ZIP code
                        LastGeoCodedCornerZip = zip;
                        stops[k] = {
                          ...stops[k],
                          zip: zip
                        };
                      }
                    });
                   
                    stops[k] = {
                      ...stops[k],
                      street: addressComponents[0].long_name + " " + addressComponents[1].long_name,
                      name: addressComponents[0].long_name + " " + addressComponents[1].long_name,
                      bPublished:true
                    };
                     
                  }
                }
                catch(err){
                  await geocoder.geocode({ location: { lat: stops[k].lat, lng: stops[k].lon } }, (midResults, midStatus) => {
                    if (midStatus === window.google.maps.GeocoderStatus.OK) {
                      // console.log("got here", midResults, midStatus);
                      complAdr = "";
                      const midAddress = midResults[0].formatted_address;
        
                      let frmtAddr = addressComponenets.find(item => item.key === "formatted_address");
                      frmtAddr.value = midAddress;
        
                      const addressComponents = midResults[0].address_components;
                    
                      let city = "";
                      let state = "";
                      let zip = "";
        
                      
                      addressComponents.forEach(component => {
                        // console.log("got to address",addressComponenets);
                        if (component.types.includes("locality")) {
                          city = component.long_name; // City
                          let cty = addressComponenets.find(item => item.key === "city");
                          cty.value = city;
                        }
                        if (component.types.includes("administrative_area_level_1")) {
                          state = component.short_name; // State
                          LastGeoCodedCornerState = state;
                          let st = addressComponenets.find(item => item.key === "state");
                          st.value = state;
                          stops[k] = {
                            ...stops[k],
                            state: state
                          };
                        }
                        if (component.types.includes("postal_code")) {
                          zip = component.long_name; // ZIP code
                          LastGeoCodedCornerZip = zip;
                          let zp = addressComponenets.find(item => item.key === "zip");
                          zp.value = zip;
                          stops[k] = {
                            ...stops[k],
                            zip: zip
                          };
                        }
                        // console.log(stops[k], city, zip, state);
                      });
                      stops[k] = {
                        ...stops[k],
                        street: midAddress,
                        name: midAddress,
                        bPublished:true
                      };
        
                      //alert(city + " " + state + " " + zip);
                    } else {
                      stops[k] = {
                        ...stops[k],
                        name: k
                      };
                    }
                  });
                }

                filteredStops.push(stops[k]);
              }

              else{

                if(NoOfStopsToSave < 1 || (NoOfStopsToSave > 0 && k < NoOfStopsToSave + MinStopsCounToRevGeoCode)) {

                  stops[k] = {
                    ...stops[k],
                    state: LastGeoCodedCornerState,
                    zip: LastGeoCodedCornerZip,
                    street: "Stop " + k,
                    name: "Stop " + k
                  };
                  filteredStops.push(stops[k]);
                }
    
              }

              
            }
          }
          // Check if the number of stops is greater than 100
          // const getlimitedStops = stops.length > 100 ? stops.slice(0, 100) : stops;
        
          // Set the stops to the state

          setBusStops(filteredStops);
          console.log('Bus Stops ', filteredStops)
          if (onSearchComplete) {
            onSearchComplete();
          }
          console.log('Bus Stops ', filteredStops)
      } catch (error) {
          console.error('Error fetching bus stops:', error);
      }
  };
  
  const fetchIntersectionsWithinPolygon = async (polygonCoordinates)=>{

    try 
    {

        const params ={
          polygon_coords:polygonCoordinates
        }

        let response = await APICom.fetchData("main", "street_intersections/get_Intersections_Within_Polygon", "post", {}, params, xCancelSourceForGrid.current)
      
        const data = await response.data.stops;
       
        // Map stops data to the desired format
        let all_stops = data.map(element => ({
          lat: element.lat, // Latitude from the API
          lon: element.lon, // Longitude from the API
          name: element.name || "", // Optional name, default to empty string if not available
          street: element.street || "", // Optional street, default to empty string if not available
          state: element.state || "", // Optional state, default to empty string if not available
          zip: element.zip || "", // Optional ZIP code, default to empty string if not available
          bPublished: false,
          showOnMap:true
        }));

        let stops = all_stops

        // Fetch POIs data
        let poiData = await fetchBusStopsWithinPolygonWithPOIsOnly(polygonCoordinates);
        if(poiData != -1)
        {
          const cityObj = addressComponentsRef.current.find(item => item.key === "city");
          const stateObj = addressComponentsRef.current.find(item => item.key === "state");
          const zipObj = addressComponentsRef.current.find(item => item.key === "zip");

          const city = cityObj.value? cityObj.value : "";
          const state = stateObj.value? stateObj.value : "";
          const zip = zipObj.value? zipObj.value : "";

          let filteredStops = [];
          let filteredPOIStops = [];

          for(let i = 0; i < poiData.length; i++)
            {
    
              poiData[i] = {
                ...poiData[i],
                city: city,
                state: state,
                zip: zip,
              };
              filteredPOIStops.push(poiData[i]);
    
            }
          
          for(let k = 0; k < stops.length; k++)
          {

            stops[k] = {
              ...stops[k],
              city: city,
              state: state,
              zip: zip,
              street: "Stop " + k,
              name: "Stop " + k
            };
            filteredStops.push(stops[k]);

          }

          // Append POI stops to the original stops
          filteredStops = [...filteredPOIStops, ...filteredStops];
          setremoveExistingStops(true)
          setBusStops(filteredStops);
            console.log('Bus Stops ', filteredStops)
            if (onSearchComplete) {
              onSearchComplete();
            }
            console.log('Bus Stops ', filteredStops)
       }
       else{
        setremoveExistingStops(true)
        setBusStops([]);
        if (onSearchComplete) {
          onSearchComplete("-1");
        }
       }
    } 
    catch (error) {
        console.error('Error fetching bus stops:', error);
        setremoveExistingStops(true)
        setBusStops([]);
        if (onSearchComplete) {
          onSearchComplete("-2");
        }
    }
};

  const fetchBusStopsWithinPolygonWithPOIsOnly = async (polygonCoordinates)=>{

    // Convert coordinates into the format required by Overpass API (lat lon lat lon)
    let polygonString = polygonCoordinates.map(coord => `${coord[1]} ${coord[0]}`).join(" ");

    const query = `      
        [out:json];
        (
          // Find all bus stops within the polygon
          node["highway"="bus_stop"](poly:"${polygonString}");

          // Find all public transport platforms within the polygon
          node["public_transport"="platform"](poly:"${polygonString}");

          // Find all schools within the polygon
          node["amenity"="school"](poly:"${polygonString}");

          // Find all hospitals within the polygon
          node["amenity"="hospital"](poly:"${polygonString}");

          // Find all malls within the polygon
          node["shop"="mall"](poly:"${polygonString}");

          // Find all hotels within the polygon
          node["tourism"="hotel"](poly:"${polygonString}");

          // Find all restaurants within the polygon
          node["amenity"="restaurant"](poly:"${polygonString}");

          // Find all parks within the polygon
          node["leisure"="park"](poly:"${polygonString}");

          // Find all recreation centers within the polygon
          node["leisure"="recreation_ground"](poly:"${polygonString}");

          // Find all daycare centers within the polygon
          node["amenity"="childcare"](poly:"${polygonString}");

          // Find all gas stations within the polygon
          node["amenity"="fuel"](poly:"${polygonString}");

          // Find all cafes within the polygon
          node["amenity"="cafe"](poly:"${polygonString}");

          // Find all bars within the polygon
          node["amenity"="bar"](poly:"${polygonString}");

          // Find all fast food places within the polygon
          node["amenity"="fast_food"](poly:"${polygonString}");

          // Find all pharmacies within the polygon
          node["amenity"="pharmacy"](poly:"${polygonString}");

          // Find all police stations within the polygon
          node["amenity"="police"](poly:"${polygonString}");

          // Find all fire stations within the polygon
          node["amenity"="fire_station"](poly:"${polygonString}");

          // Find all banks within the polygon
          node["amenity"="bank"](poly:"${polygonString}");

          // Find all ATMs within the polygon
          node["amenity"="atm"](poly:"${polygonString}");

          // Find all post offices within the polygon
          node["amenity"="post_office"](poly:"${polygonString}");

          // Find all parking areas within the polygon
          node["amenity"="parking"](poly:"${polygonString}");

          // Find all cinemas within the polygon
          node["amenity"="cinema"](poly:"${polygonString}");

          // Find all museums within the polygon
          node["tourism"="museum"](poly:"${polygonString}");


        );
        out body;
        >;
        out skel qt;
      `;
      
      const url = `https://overpass-api.de/api/interpreter`;

      try {
        const response = await fetch(url, {
          method: "POST",
          headers:{
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: `data=${encodeURIComponent(query)}`
        });
          const data = await response.json();
          let stops = data.elements.map(element => ({
            lat: element.lat,
            lon: element.lon,
            name: (element.tags.name ? element.tags.name : (element.tags["addr:street"] ? element.tags["addr:street"] : '')),
            street: (element.tags.name ? element.tags.name : (element.tags["addr:street"] ? element.tags["addr:street"] : '')),
            state: (element.tags["addr:state"] ? element.tags["addr:state"] : ''),
            zip: (element.tags["addr:postcode"] ? element.tags["addr:postcode"] : ''),
            bPublished: true,
            showOnMap:true
          }));

          stops = stops.filter(stop => !(stop.name === '' && stop.street === ''));

          return stops
      } catch (error) {
          console.error('Error fetching bus stops:', error);
          return -1;
      }
  };


  const fetchBusStopsWithPolygon = async (polygonCoordinates)=>{
    const query = `      
        [out:json];
        (
          // Find all bus stops within the polygon
          node["highway"="bus_stop"](poly:"${polygonCoordinates}");

          // Find all public transport platforms within the polygon
          node["public_transport"="platform"](poly:"${polygonCoordinates}");

          // Find all schools within the polygon
          node["amenity"="school"](poly:"${polygonCoordinates}");

          // Find all hospitals within the polygon
          node["amenity"="hospital"](poly:"${polygonCoordinates}");

          // Find all malls within the polygon
          node["shop"="mall"](poly:"${polygonCoordinates}");

          // Find all hotels within the polygon
          node["tourism"="hotel"](poly:"${polygonCoordinates}");

          // Find all restaurants within the polygon
          node["amenity"="restaurant"](poly:"${polygonCoordinates}");

          // Find all parks within the polygon
          node["leisure"="park"](poly:"${polygonCoordinates}");

          // Find all recreation centers within the polygon
          node["leisure"="recreation_ground"](poly:"${polygonCoordinates}");

          // Find all daycare centers within the polygon
          node["amenity"="childcare"](poly:"${polygonCoordinates}");

          // Find all gas stations within the polygon
          node["amenity"="fuel"](poly:"${polygonCoordinates}");

          // Find all cafes within the polygon
          node["amenity"="cafe"](poly:"${polygonCoordinates}");

          // Find all bars within the polygon
          node["amenity"="bar"](poly:"${polygonCoordinates}");

          // Find all fast food places within the polygon
          node["amenity"="fast_food"](poly:"${polygonCoordinates}");

          // Find all pharmacies within the polygon
          node["amenity"="pharmacy"](poly:"${polygonCoordinates}");

          // Find all police stations within the polygon
          node["amenity"="police"](poly:"${polygonCoordinates}");

          // Find all fire stations within the polygon
          node["amenity"="fire_station"](poly:"${polygonCoordinates}");

          // Find all banks within the polygon
          node["amenity"="bank"](poly:"${polygonCoordinates}");

          // Find all ATMs within the polygon
          node["amenity"="atm"](poly:"${polygonCoordinates}");

          // Find all post offices within the polygon
          node["amenity"="post_office"](poly:"${polygonCoordinates}");

          // Find all parking areas within the polygon
          node["amenity"="parking"](poly:"${polygonCoordinates}");

          // Find all cinemas within the polygon
          node["amenity"="cinema"](poly:"${polygonCoordinates}");

          // Find all museums within the polygon
          node["tourism"="museum"](poly:"${polygonCoordinates}");


        );
        out body;
        >;
        out skel qt;
      `;
      
      const url = `https://overpass-api.de/api/interpreter`;

      try {
        const response = await fetch(url, {
          method: "POST",
          headers:{
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: `data=${encodeURIComponent(query)}`
        });
          const data = await response.json();
          const geocoder = new window.google.maps.Geocoder();
          let complAdr = "";
          let all_stops = data.elements.map(element => ({
            lat: element.lat,
            lon: element.lon,
            name: (element.tags.name ? element.tags.name : (element.tags["addr:street"] ? element.tags["addr:street"] : '')),
            street: (element.tags["addr:street"] ? element.tags["addr:street"] : ''),
            state: (element.tags["addr:state"] ? element.tags["addr:state"] : ''),
            zip: (element.tags["addr:postcode"] ? element.tags["addr:postcode"] : ''),
          }));

          // Randomize and get 100 points
          const gridSize = 10;
          const stops = all_stops.length > 100 ? scatterPointsEvenly(all_stops, gridSize, 100): all_stops;
          
          // const stops = all_stops.length > 100 ? getRandomizedIntersections(all_stops, 100): all_stops;
          // let stops = all_stops.length > 100 ? all_stops.slice(0, 100) : all_stops;
          
          for(let k = 0; k < stops.length; k++)
          {
            if(stops[k].name === '' && stops[k].street === '')
            {
              // console.log("went here", stops[k]);
              try{
                let reverseGeocodeResponse = await ReverseGeoCode(stops[k].lat, stops[k].lon);
                if(reverseGeocodeResponse && reverseGeocodeResponse.data.status.toUpperCase() === "OK")
                {
                  const addressComponents = reverseGeocodeResponse.data.results[0].address_components;
                  
                  addressComponents.forEach(component => {
                    let state = "";
                    let zip = "";
                    if (component.types.includes("administrative_area_level_1")) {
                      state = component.short_name; // State
                      stops[k] = {
                        ...stops[k],
                        state: state
                      };
                    }
                    if (component.types.includes("postal_code")) {
                      zip = component.long_name; // ZIP code
                      stops[k] = {
                        ...stops[k],
                        zip: zip
                      };
                    }
                  });
                  stops[k] = {
                    ...stops[k],
                    street: reverseGeocodeResponse.data.results[0].formatted_address,
                    name: reverseGeocodeResponse.data.results[0].formatted_address
                  };
                   
                }
              }
              catch(err){
                await geocoder.geocode({ location: { lat: stops[k].lat, lng: stops[k].lon } }, (midResults, midStatus) => {
                  if (midStatus === window.google.maps.GeocoderStatus.OK) {
                    // console.log("got here", midResults, midStatus);
                    complAdr = "";
                    const midAddress = midResults[0].formatted_address;
      
                    let frmtAddr = addressComponenets.find(item => item.key === "formatted_address");
                    frmtAddr.value = midAddress;
      
                    const addressComponents = midResults[0].address_components;
                  
                    let city = "";
                    let state = "";
                    let zip = "";
      
                    
                    addressComponents.forEach(component => {
                      // console.log("got to address",addressComponenets);
                      if (component.types.includes("locality")) {
                        city = component.long_name; // City
                        let cty = addressComponenets.find(item => item.key === "city");
                        cty.value = city;
                      }
                      if (component.types.includes("administrative_area_level_1")) {
                        state = component.short_name; // State
                        let st = addressComponenets.find(item => item.key === "state");
                        st.value = state;
                        stops[k] = {
                          ...stops[k],
                          state: state
                        };
                      }
                      if (component.types.includes("postal_code")) {
                        zip = component.long_name; // ZIP code
                        let zp = addressComponenets.find(item => item.key === "zip");
                        zp.value = zip;
                        stops[k] = {
                          ...stops[k],
                          zip: zip
                        };
                      }
                      // console.log(stops[k], city, zip, state);
                    });
                    stops[k] = {
                      ...stops[k],
                      street: midAddress,
                      name: midAddress
                    };
      
                    //alert(city + " " + state + " " + zip);
                  } else {
                    stops[k] = {
                      ...stops[k],
                      name: k
                    };
                  }
                });
              }
              
              // await geocoder.geocode({ location: { lat: stops[k].lat, lng: stops[k].lon } }, (midResults, midStatus) => {
              //   if (midStatus === window.google.maps.GeocoderStatus.OK) {
              //     // console.log("got here", midResults, midStatus);
              //     complAdr = "";
              //     const midAddress = midResults[0].formatted_address;
    
              //     let frmtAddr = addressComponenets.find(item => item.key === "formatted_address");
              //     frmtAddr.value = midAddress;
    
              //     const addressComponents = midResults[0].address_components;
                 
              //     let city = "";
              //     let state = "";
              //     let zip = "";
    
                  
              //     addressComponents.forEach(component => {
              //       // console.log("got to address",addressComponenets);
              //       if (component.types.includes("locality")) {
              //         city = component.long_name; // City
              //         let cty = addressComponenets.find(item => item.key === "city");
              //         cty.value = city;
              //       }
              //       if (component.types.includes("administrative_area_level_1")) {
              //         state = component.short_name; // State
              //         let st = addressComponenets.find(item => item.key === "state");
              //         st.value = state;
              //         stops[k] = {
              //           ...stops[k],
              //           state: state
              //         };
              //       }
              //       if (component.types.includes("postal_code")) {
              //         zip = component.long_name; // ZIP code
              //         let zp = addressComponenets.find(item => item.key === "zip");
              //         zp.value = zip;
              //         stops[k] = {
              //           ...stops[k],
              //           zip: zip
              //         };
              //       }
              //       // console.log(stops[k], city, zip, state);
              //     });
              //     stops[k] = {
              //       ...stops[k],
              //       street: midAddress,
              //       name: midAddress
              //     };
    
              //     //alert(city + " " + state + " " + zip);
              //   } else {
    
              //   }
              // });
            }
          }
          // Check if the number of stops is greater than 100
          // const getlimitedStops = stops.length > 100 ? stops.slice(0, 100) : stops;
        
          // Set the stops to the state

          setBusStops(stops);
          console.log('Bus Stops ', stops)
          if (onSearchComplete) {
            onSearchComplete();
          }
          console.log('Bus Stops ', stops)
      } catch (error) {
          console.error('Error fetching bus stops:', error);
      }
  };

  function scatterPointsEvenly(points, gridSize, limit = 100) {
    const [minLat, maxLat] = [Math.min(...points.map(p => p.lat)), Math.max(...points.map(p => p.lat))];
    const [minLon, maxLon] = [Math.min(...points.map(p => p.lon)), Math.max(...points.map(p => p.lon))];
    
    const latStep = (maxLat - minLat) / gridSize;
    const lonStep = (maxLon - minLon) / gridSize;
  
    // Create grid cells
    const grid = new Map();
  
    points.forEach((p) => {
      const latIndex = Math.floor((p.lat - minLat) / latStep);
      const lonIndex = Math.floor((p.lon - minLon) / lonStep);
      const key = `${latIndex},${lonIndex}`;
  
      if (!grid.has(key)) grid.set(key, []);
      grid.get(key).push(p);
    });
  
    // Select points evenly from the grid
    const selectedPoints = [];
    grid.forEach((cellPoints) => {
      const randomPoint = cellPoints[Math.floor(Math.random() * cellPoints.length)];
      selectedPoints.push(randomPoint);
    });
  
    // Limit to 100 points
    return selectedPoints.slice(0, limit);
  }


  function getRandomizedIntersections(data, limit = 100) {
    // Shuffle the data randomly
    const shuffled = data.sort(() => Math.random() - 0.5);
    return shuffled.slice(0, limit); // Get the first 100 random points
  }

  const drawPolygonByName = (locationName, savedLocalPolygoneDataFromDb = "") => {
    if (!map) return;
    handleResetPolygon();


    const geocoder = new window.google.maps.Geocoder();
    let polygonCoords = [];
    //Extra 
    const RADIUS_IN_MILES = 2; // Radius in miles
    const RADIUS_IN_METERS = RADIUS_IN_MILES * 1609.34; // Convert miles to meters
    const NUM_VERTICES = 32; // Number of vertices for the polygon (higher number = smoother circle)
    // // 

    geocoder.geocode({ address: locationName }, (results, status) => {

        const distanceInKm = 2;
        const offset = distanceInKm * 0.009; // For latitude and longitude at the equator
      if (status === window.google.maps.GeocoderStatus.OK) {
        const coordinates = results[0].geometry.location;
        if (savedLocalPolygoneDataFromDb != ""
            && savedLocalPolygoneDataFromDb != undefined
            && savedLocalPolygoneDataFromDb != null) {
          let splittedCoordinates = savedLocalPolygoneDataFromDb.split(",");
          for (let i = 0; i < splittedCoordinates.length; i += 2) {
            try {
              let lat = parseFloat(splittedCoordinates[i]);
              let lng = parseFloat(splittedCoordinates[i + 1]);
              polygonCoords.push({lat: lat, lng: lng});
            } catch (error) {

            }
          }
        }else {
          polygonCoords = [
            {lat: coordinates.lat() + offset, lng: coordinates.lng() - offset},
            {lat: coordinates.lat() + offset, lng: coordinates.lng() + offset},
            {lat: coordinates.lat() - offset, lng: coordinates.lng() + offset},
            {lat: coordinates.lat() - offset, lng: coordinates.lng() - offset}
          ];
        }
      } else {

        if (savedLocalPolygoneDataFromDb != ""
            && savedLocalPolygoneDataFromDb != undefined
            && savedLocalPolygoneDataFromDb != null) {
          let splittedCoordinates = savedLocalPolygoneDataFromDb.split(",");
          for (let i = 0; i < splittedCoordinates.length; i += 2) {
            try {
              let lat = parseFloat(splittedCoordinates[i]);
              let lng = parseFloat(splittedCoordinates[i + 1]);
              polygonCoords.push({lat: lat, lng: lng});
            } catch (error) {

            }
          }
        }
      }

      if (polygonCoords.length > 0) {


        // Create and display the polygon
        const newPolygon = new window.google.maps.Polygon({
          paths: polygonCoords,
          strokeColor: '#FF0000',
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: '#FF0000',
          fillOpacity: 0.35,
          editable: true
        });

        newPolygon.setMap(map);
        setPolygon(newPolygon);

        //Get Mid Address\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\
        try {
          const midLat = (polygonCoords[0].lat + polygonCoords[1].lat + polygonCoords[2].lat + polygonCoords[3].lat) / 4;
          const midLng = (polygonCoords[0].lng + polygonCoords[1].lng + polygonCoords[2].lng + polygonCoords[3].lng) / 4;
          const midpoint = {lat: midLat, lng: midLng};

          // Reverse geocode the midpoint to find the address
          let complAdr = "";
          geocoder.geocode({location: midpoint}, (midResults, midStatus) => {
            if (midStatus === window.google.maps.GeocoderStatus.OK) {
              complAdr = "";
              const midAddress = midResults[0].formatted_address;

              let frmtAddr = addressComponenets.find(item => item.key === "formatted_address");
              frmtAddr.value = midAddress;

              const addressComponents = midResults[0].address_components;

              let city = "";
              let state = "";
              let zip = "";


              addressComponents.forEach(component => {
                if (component.types.includes("locality")) {
                  city = component.long_name; // City
                  let cty = addressComponenets.find(item => item.key === "city");
                  cty.value = city;
                  complAdr += "city=" + city;
                }
                if (component.types.includes("administrative_area_level_1")) {
                  state = component.short_name; // State
                  let st = addressComponenets.find(item => item.key === "state");
                  st.value = state;
                  complAdr += "!state=" + state;
                }
                if (component.types.includes("postal_code")) {
                  zip = component.long_name; // ZIP code
                  let zp = addressComponenets.find(item => item.key === "zip");
                  zp.value = zip;
                  complAdr += "!zip=" + zip;
                }
              });
              complAdr += "!completeAddress=" + midAddress;
              complAdr += "!lat=" + midLat;
              complAdr += "!lng=" + midLng;

              let completeAddress = addressComponenets.find(item => item.key === "CompleteAddresscomponent");
              completeAddress.value = complAdr;
              AddressComponentData(addressComponenets);
              addressComponentsRef.current = addressComponenets;
              console.log(addressComponenets);

            } else {

            }
          });
        } catch (error) {

        }
        //Get Mid Address\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\


        // Center map and zoom in to fit the polygon
        const bounds = new window.google.maps.LatLngBounds();
        polygonCoords.forEach(coord => {
          bounds.extend(new window.google.maps.LatLng(coord.lat, coord.lng));
        });
        map.fitBounds(bounds);
        // if (onSearchComplete) {
        //   AddressComponentData(addressComponenets);
        //   onSearchComplete();
        // }


        let polygonCoordinates = [];

        let reducedCoordinates = [];


        reducedCoordinates = polygonCoords;
        
        // for (let y = 0; y < reducedCoordinates.length; y++) {

        //   if (y !== 0) {
        //     polygonCoordinates += " ";
        //   }
        //   polygonCoordinates += reducedCoordinates[y].lat + ' ' + reducedCoordinates[y].lng;
        // }


        for (let y = 0; y < reducedCoordinates.length; y++) {
          polygonCoordinates.push([reducedCoordinates[y].lng, reducedCoordinates[y].lat]); // [longitude, latitude]
        }



        fetchIntersectionsWithinPolygon(polygonCoordinates);
      }

      else {
        alert("Please search valid name");
        onSearchComplete();

      }
    });

  }; 

  useEffect(() => {
    // if (IsResetBtnClicked) 
    // {
    //   handleResetPolygon();
    // }
    setLocalIsRestButtonClicked(IsResetBtnClicked);
  }, [IsResetBtnClicked]);

  useEffect(() => {
    if (map && localIsRestButtonClicked) {
      handleResetPolygon();
      
    }
  },[localIsRestButtonClicked])

  const handleResetPolygon = () => {
    if (polygon) {
      polygon.setMap(null);
      setPolygon(null);
      setStops(null)
      if(onResetComplete){
        onResetComplete();
      }
    }
  };

    // Synchronize local state with parent's initialStops prop
    useEffect(() => {
      setremoveExistingStops(false)
      setStops(initialStops);
    }, [initialStops]); // Update when parent changes initialStops


    useEffect(() => {
      if (!map) return;
    
      if (removeExistingStops) {
        // Remove all existing markers
        markersRef.current.forEach((marker) => {
          marker.setMap(null);
        });
        markersRef.current.clear();
      }
    
      const newMarkers = new Map();
    
      stops?.forEach(stop => {
        const stopKey = `${stop.lat}-${stop.lon}`;
    
        if (markersRef.current.has(stopKey)) {
          // Marker exists, check if `showOnMap` changed
          const existingMarker = markersRef.current.get(stopKey);
    
          if (!stop.showOnMap) {
            // Remove marker if `showOnMap` changed to false
            existingMarker.setMap(null);
            markersRef.current.delete(stopKey);
          } else {
            // Update marker color if `bPublished` changed
            if (
              existingMarker.getIcon().fillColor !== (stop.bPublished ? 'darkorange' : 'black')
            ) {
              existingMarker.setIcon({
                path: window.google.maps.SymbolPath.CIRCLE,
                fillColor: stop.bPublished ? 'darkorange' : 'black',
                fillOpacity: 0.6,
                strokeColor: 'black',
                strokeWeight: 1,
                strokeOpacity: 0.9,
                scale: 4,
              });
            }
            newMarkers.set(stopKey, existingMarker); // Keep marker
          }
        } else {
          // New marker (only if `showOnMap` is true)
          if (stop.showOnMap) {
            const marker = new window.google.maps.Marker({
              position: { lat: stop.lat, lng: stop.lon },
              icon: {
                path: window.google.maps.SymbolPath.CIRCLE,
                fillColor: stop.bPublished ? 'darkorange' : 'black',
                fillOpacity: 0.6,
                strokeColor: 'black',
                strokeWeight: 1,
                strokeOpacity: 0.9,
                scale: 4,
              },
              map: map,
            });
    
            newMarkers.set(stopKey, marker);
          }
        }
      });
    
      // Update the marker reference
      markersRef.current = newMarkers;
    }, [stops, map, removeExistingStops]);
    


  return (
    <div id="mapControlRCZ" style={{ height: '100%', width: '100%' }} ref={mapRef}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: 'AIzaSyCUZiQELkgLvz9RFYDCl4Lsetn3H54jaXI', libraries: 'drawing' }} yesIWantToUseGoogleMapApiInternals defaultCenter={center} defaultZoom={zoom}
        // styles={mapStyles}
        
        onGoogleApiLoaded={({ map, maps }) => {
            //map.setOptions({ styles: mapStyles });
            map.setOptions({ styles: null });
            setMap(map)
            console.log('Map:', map);
            console.log('Maps:', maps);
        }}>
       
      </GoogleMapReact>
    </div>
  );
});

export default RCZControlMap;
